import { api } from "~/utils/api";
import { deobfuscate } from "~/utils/obfuscate";
import { ApiQueryEndpoints, ApiQuery } from "../types";

// // // //

const selectDeobfuscate = (data: unknown) => deobfuscate(data as string);

// ENHANCEMENT - update useApiQuery to be a lil more type safe?
export function useApiQuery(props: {
    endpoint: ApiQueryEndpoints;
    query: ApiQuery;
    options?: {
        keepPreviousData?: boolean;
    };
}) {
    const { endpoint, query } = props;

    if (endpoint === ApiQueryEndpoints.AssetTimeseriesV4) {
        return api.assetTimeseriesV4.queryTimeseries.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                staleTime: Infinity,
                trpc: { context: { skipBatch: true } },
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.AssetAggregatesV4) {
        return api.assetTimeseriesV4.queryAggregates.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                staleTime: Infinity,
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.TransactionsV4) {
        return api.transactions.query.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                staleTime: Infinity,
                trpc: { context: { skipBatch: true } },
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.IssuerV4) {
        return api.issuers.query.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.AssetV4) {
        return api.assets.query.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                trpc: { context: { skipBatch: true } },
                select: selectDeobfuscate,
                keepPreviousData: props.options?.keepPreviousData,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.ServiceProviderV4) {
        return api.serviceProvidersV4.query.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.AssetClassV4) {
        return api.assetClassesV4.query.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.TokenV4) {
        return api.tokens.query.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                staleTime: Infinity,
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.NetworkV4) {
        return api.networksV4.queryNetworks.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.PlatformV4) {
        return api.platforms.query.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.ProtocolV4) {
        return api.platforms.query.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.ManagerV4) {
        return api.managers.query.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.TokenTimeseriesV4) {
        return api.tokenTimeseries.queryTimeseries.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                staleTime: Infinity,
                trpc: { context: { skipBatch: true } },
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.TokenAggregatesV4) {
        return api.tokenTimeseries.queryAggregates.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                staleTime: Infinity,
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.FundFlowsTimeseriesV4) {
        return api.fundFlows.queryTimeseries.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                staleTime: Infinity,
                trpc: { context: { skipBatch: true } },
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.FundFlowsV4) {
        return api.fundFlows.query.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                staleTime: Infinity,
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.TokenHoldersV4) {
        return api.tokenHolders.query.useQuery(
            { query },
            {
                refetchOnWindowFocus: false,
                select: selectDeobfuscate,
            },
        );
    }

    if (endpoint === ApiQueryEndpoints.MeasureV4) {
        return api.measures.query.useQuery(
            { query },
            { refetchOnWindowFocus: false },
        );
    }

    if (endpoint === ApiQueryEndpoints.ReferenceDataV4) {
        return api.referenceData.query.useQuery(
            { query },
            { refetchOnWindowFocus: false },
        );
    }

    throw new Error(
        `ApiQueryEndpoint Not Supported in useApiQuery: ${endpoint}`,
    );
}
